import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-play-circle-fill text-2xl ${isScrolled || !isHome ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span className={`text-xl font-heading font-bold ${isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'}`}>
              玖玖视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? isScrolled || !isHome ? 'text-primary-600 bg-primary-50' : 'text-background-50 bg-white/20'
                  : isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').slice(0, 6).map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? isScrolled || !isHome ? 'text-primary-600 bg-primary-50' : 'text-background-50 bg-white/20'
                    : isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? isScrolled || !isHome ? 'text-primary-600 bg-primary-50' : 'text-background-50 bg-white/20'
                  : isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索视频..."
                className={`w-48 px-4 py-2 pl-9 rounded-full text-sm border transition-all focus:outline-none focus:w-64 ${
                  isScrolled || !isHome
                    ? 'bg-background-100 border-background-200 text-foreground-800 placeholder-foreground-400 focus:border-primary-300'
                    : 'bg-white/15 border-white/20 text-background-50 placeholder-background-50/50 focus:border-white/40 focus:bg-white/25'
                }`}
              />
              <i className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm ${isScrolled || !isHome ? 'text-foreground-400' : 'text-background-50/60'}`}></i>
            </div>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              isScrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 py-4 px-4">
          <div className="mb-4">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索视频..."
              className="w-full px-4 py-2.5 pl-10 rounded-full text-sm border border-background-200 bg-background-100 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
            />
            <i className="ri-search-line absolute text-foreground-400 text-sm ml-3.5 -mt-9 block"></i>
          </div>
          <div className="flex flex-col gap-1">
            <Link to="/" className="px-4 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 cursor-pointer">首页</Link>
            {categories.filter(c => c.slug !== 'all').map(cat => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 cursor-pointer">{cat.name}</Link>
            ))}
            <Link to="/about" className="px-4 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 cursor-pointer">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}